// Module
var code = "<div class=\"col-12\"> <p class=\"mt-2\">There are no events scheduled for this program. Please visit the link below to see all upcoming and on-demand information sessions.</p> </div>";
// Exports
export default code;